import WebsiteBehaviors from "../website-behaviors/index.js";
import {getLocationTest, getIdsFromPath, generateEdsCitation} from "./EbscoResearch.js";

/**
 * 2023-07-27
 * It seems that discvoery.ebsco.com urls are now redirecting to
 * research.ebsco.com urls. Keeping this special case in for now in case it's
 * still somehow being used. This can probably be removed at a later time when
 * we're pretty sure that discovery.ebsco.com urls aren't used anymore.
 **/

class EbscoDiscovery extends WebsiteBehaviors {
	identifier() {
		return "EbscoDiscovery";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		/**
		 * Url examples:
		 * https://discovery.ebsco.com/c/c4ett2/details/c6murbvzxv?q=Complete+Guide+to+Pruning+Trees+%26+Bushes%3A+Everything+You+Need+to+Know+Explained+Simply&db=bwh%2Cbth%2Ca9h%2Cnlebk%2Ce864sww%2Cf6h
		* https://discovery.ebsco.com/c/c4ett2/viewer/html/nm5ymf76pv
		* https://discovery.ebsco.com/c/c4ett2/viewer/pdf/c6murbvzxv
		 **/
		return getLocationTest("discovery");
	}

	async init() {
		await super.init();

		// Get permalink
		if (!document.documentElement.getAttribute("data-pn-url")) {
			const {profileIdentifier, recordId} = getIdsFromPath();

			const result = await fetch("https://discovery.ebsco.com/api/viewer/v2/plink", {
				headers: {
					"content-type": "application/json"
				},
				body:   JSON.stringify({profileIdentifier, recordId}),
				method: "POST"
			});

			const plink = await result.json();

			document.documentElement.setAttribute("data-pn-url", plink.value);
		}
	}

	async generateStructuredCitation() {
		return generateEdsCitation("discovery");
	}
}

export default EbscoDiscovery;
